export default "__VITE_ASSET__a6b72b00__"